import { render, staticRenderFns } from "./startTest.vue?vue&type=template&id=58688f1b&scoped=true&"
import script from "./startTest.vue?vue&type=script&lang=js&"
export * from "./startTest.vue?vue&type=script&lang=js&"
import style0 from "./startTest.vue?vue&type=style&index=0&id=58688f1b&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58688f1b",
  null
  
)

export default component.exports